// CoursesAndActivitiesSection.js
import React from "react";

const CoursesAndActivitiesSection = ({ cursosList, actividadesList }) => {
  return (
    <div className="maestra-info">
      <h5>Lista de Cursos</h5>
      {cursosList.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Año</th>
              <th>Nombre</th>
              <th>Comuna</th>

              <th>Aprobado</th>
            </tr>
          </thead>
          <tbody>
            {cursosList.map((curso, index) => (
              <tr key={index}>
                <td>{curso.f_inicio}</td>
                <td>
                  <a href={`/cursos/${curso.id}`}>{curso.nombre}</a>
                </td>
                <td>{curso.comuna}</td>

                <td>{curso.aprobado}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay cursos disponibles.</p>
      )}

      <h5>Lista de Actividades</h5>
      {actividadesList.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Año</th>
              <th>Nombre</th>
              <th>Comuna</th>

              <th>Aprobado</th>
            </tr>
          </thead>
          <tbody>
            {actividadesList.map((actividad, index) => (
              <tr key={index}>
                <td>{actividad.f_inicio}</td>
                <td>
                  <a href={`/actividades/${actividad.id}`}>
                    {actividad.nombre}
                  </a>
                </td>
                <td>{actividad.comuna}</td>

                <td>{actividad.aprobado}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay actividades disponibles.</p>
      )}
    </div>
  );
};

export default CoursesAndActivitiesSection;
